import type { StatusTone } from '@vnetwork/ui/data';

/** Title-case a dash/underscore slug for display labels. */
export function humanize(value?: string | null): string {
  if (!value) return '—';
  return value
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** Affiliate status → StatusPill tone. */
export function affiliateTone(status?: string): StatusTone {
  switch (status) {
    case 'active':
      return 'success';
    case 'pending':
      return 'warning';
    case 'suspended':
      return 'danger';
    case 'inactive':
    default:
      return 'neutral';
  }
}

/** Payout status → StatusPill tone. */
export function payoutTone(status?: string): StatusTone {
  switch (status) {
    case 'completed':
      return 'success';
    case 'approved':
    case 'processing':
      return 'info';
    case 'pending':
      return 'warning';
    case 'failed':
    case 'cancelled':
      return 'danger';
    default:
      return 'neutral';
  }
}

/** Commission status → StatusPill tone. */
export function commissionTone(status?: string): StatusTone {
  switch (status) {
    case 'confirmed':
      return 'success';
    case 'pending':
      return 'warning';
    case 'refunded':
      return 'danger';
    default:
      return 'neutral';
  }
}

/** Invoice status → StatusPill tone. */
export function invoiceTone(status?: string): StatusTone {
  switch (status) {
    case 'paid':
    case 'done':
      return 'success';
    case 'approved':
    case 'waiting-confirm':
      return 'info';
    case 'cancelled':
    case 'rejected':
      return 'danger';
    default:
      return 'neutral';
  }
}

/** Commission policy scope → StatusPill tone. */
export function scopeTone(scope?: string): StatusTone {
  switch (scope) {
    case 'product':
      return 'success';
    case 'product_group':
      return 'info';
    case 'default':
    default:
      return 'neutral';
  }
}
